module.exports = __webpack_public_path__ + "static/media/add_content.07f5242a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/add_content.jpg
// module id = 265
// module chunks = 0